module.exports = __webpack_public_path__ + "static/media/practice.526406fb.svg";